import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { VehicleManufacturer } from '../../model/vehicleManufacturer';
import { Essentials } from '../../util/essentials';

@Component({
  selector: 'filter-vehicle',
  templateUrl: './filter-vehicle.component.html',
  styleUrls: ['./filter-vehicle.component.css']
})
export class FilterVehicleComponent implements OnInit {

  @Output() filterVehicleClicked: EventEmitter<any> = new EventEmitter();
  @ViewChild('vehicleManufacturer') inputManufacture;
  @ViewChild('vehicleModel') inputModel;
  @ViewChild('vehicleColor') inputColor;

  public selectedPlate: string = '';
  public selectedRfid: string = '';
  public selectedManufacturer: string = '';
  public selectedModel: string = '';
  public selectedColor: string = '';

  filteredManufacturers$: Observable<string[]>;
  filteredModels$: Observable<string[]>;
  filteredColors$: Observable<string[]>;

  vehicleManufacturers: VehicleManufacturer[] = [];
  manufacturersFields: string[] = [''];
  modelsFields: string[] = [''];
  colorsFields: string[] = [''];
  vehicleColors: { id: number, color: string }[] = [];

  habilitedModel: boolean = true;

  private filterData: {
    selectedPlate: string,
    selectedRfid: string,
    selectedManufacturer: string,
    selectedModel: string,
    selectedColor: string
  }

  constructor(private essentials: Essentials,) { }

  ngOnInit(): void {

    this.filterData = {
      selectedPlate: '',
      selectedRfid: '',
      selectedManufacturer: '',
      selectedModel: '',
      selectedColor: ''
    }
    this.retreiveVehicleModels();
    this.retreiveVehicleColors();
  }

  retreiveVehicleModels() {
    this.essentials.getVehicleModels().subscribe(
      (manufacturers) => {
        if (manufacturers != undefined) {
          this.vehicleManufacturers = manufacturers;
          this.manufacturersFields = this.vehicleManufacturers.map(m => m.name);
          this.filteredManufacturers$ = of(this.manufacturersFields);
          this.modelsFields = [];
          this.filteredModels$ = of(this.modelsFields);
        }
      },
      (error) => {},
      () => {},
    );
  }

  retreiveVehicleColors() {
    this.essentials.getVehicleColors().subscribe(
      (colors) => {
        if (colors != undefined) {
          this.vehicleColors = colors;
          this.colorsFields = this.vehicleColors.map(c => c.color);
          this.filteredColors$ = of(this.colorsFields);
          this.vehicleColors = colors;
        }
      },
      (error) => {},
      () => {},
    );
  }

  onChangeManufacture(){
    this.filteredManufacturers$ = of(this.getFilteredOptions(this.inputManufacture.nativeElement.value, this.manufacturersFields));
  }
  onChangeModel(){
    this.filteredModels$ = of(this.getFilteredOptions(this.inputModel.nativeElement.value, this.modelsFields));
  }
  onChangeColor(){
    this.filteredColors$ = of(this.getFilteredOptions(this.inputColor.nativeElement.value, this.colorsFields));
  }

  onSelectionChangeManufacture(manufacture) {
    this.selectedManufacturer = manufacture;
  }
  onSelectionChangeModel(model) {
    this.selectedModel = model;
  }
  onSelectionChangeColor(color) {
    this.selectedColor = color;
  }

  getFilteredOptions(inputFilter: string, options: string[], errorForUnmatchedValues?: FormControl, emptyIsValid: boolean = false): string[] {
    if (options.some(optionValue => optionValue == inputFilter) || (emptyIsValid && this.isNullOrEmpty(inputFilter))) {
      if (errorForUnmatchedValues != undefined) errorForUnmatchedValues.setErrors(null);
      return options;
    }
    let matchValues = this.isNullOrEmpty(inputFilter) ? options : options.filter(optionValue => optionValue.toLowerCase().includes(inputFilter.toLowerCase()));
    if (errorForUnmatchedValues != undefined) errorForUnmatchedValues.setErrors({ 'incorrect': true });
    return matchValues;
  }

  fillInModelFields(newManuf) {
    this.selectedModel = '';
    let manufacturers: VehicleManufacturer;
    if (this.manufacturersFields.some(manuf => {
      if (manuf == newManuf && !this.isNullOrEmpty(manuf)) {
        manufacturers = this.vehicleManufacturers.find(m => m.name == manuf);
        return true;
      }
      return false;
    })) {
      this.modelsFields = manufacturers.models;
      this.habilitedModel = false;
    }
    else {
      this.habilitedModel = true;
      this.modelsFields = [];
    }
    this.filteredModels$ = of(this.modelsFields);
  }

  isNullOrEmpty(value: string) {
    return value == null || value == '';
  }

  changePickerStatus(){
    this.filterData = {
      selectedPlate: this.selectedPlate,
      selectedRfid: this.selectedRfid,
      selectedManufacturer: this.selectedManufacturer,
      selectedModel: this.selectedModel,
      selectedColor: this.selectedColor
    }

    this.filterVehicleClicked.emit(this.filterData)
  }

}
